import { RegisterNSModalActions, MEMBER_REGISTER_NSMODAL__BY_PASS_PHRASE } from 'app/store/features/member/register/nsModal/types';
import { AaSigninReq } from 'app/bff/models/aa/aaSignin';

/**
 * @description 驗證網服會員 (Action)
 * @param authMemberArgs 驗證網服帳號密碼，請求所需的參數
 */
export const registerNSModalAction = (authMemberArgs: AaSigninReq): RegisterNSModalActions => ({
  type: MEMBER_REGISTER_NSMODAL__BY_PASS_PHRASE,
  payload: { authMemberArgs }
});
